export default {
    namespaced: true,

    state: {
        startDate: null,
        endDate: null,
        excludeDepositsArMonthEnd: true,
        excludeDepositsAging: true,
        excludeOverpaymentsAging: false,
    },

    mutations: {
        setContext(state, payload) {
            state.startDate = payload.startDate;
            state.endDate = payload.endDate;
            state.excludeDepositsArMonthEnd = payload.excludeDepositsArMonthEnd;
            state.excludeDepositsAging = payload.excludeDepositsAging;
            state.excludeOverpaymentsAging = payload.excludeOverpaymentsAging;
        },

        clearContext(state) {
            state.startDate = null;
            state.endDate = null;
        },
    },
};
